import { Button, IconButton } from "@mui/material";
import { SelectedItemsContext } from "../selected/selectedItemsProvider";
import { useContextWithGuard } from "../helpers/useContextWithGuard";
import { IQuestion } from "../types";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { useAnalytics } from "../firebase/firebase";

export interface SelectAllRemoveAllProps {
    visibleQns: IQuestion[];
}

export const SelectAllRemoveAll = (props: SelectAllRemoveAllProps) => {
    const {track} = useAnalytics();
    const { selectedQns, clearSelected, addToSelected } = useContextWithGuard(SelectedItemsContext, "SelectedItemsContext");

    return (
        selectedQns.length > 0
            ?
            <IconButton
                size="large"
                edge="start"
                aria-label="deselect"
                sx={{
                    mr: 2,
                    border: 'none !important',
                }}
                aria-haspopup="true"
                onClick={() => {
                    clearSelected();
                    track("deselectAll");
                }}
                title="clear selection"
                color="primary"
            >
                {
                    props.visibleQns.length == selectedQns.length
                        ?
                        <CheckBoxIcon />
                        :
                        <IndeterminateCheckBoxIcon />
                }
            </IconButton>
            :
            <IconButton
                size="large"
                edge="start"
                aria-label="select all"
                sx={{
                    mr: 2,
                    border: 'none !important',
                }}
                aria-haspopup="true"
                onClick={() => {
                    addToSelected(props.visibleQns);
                    track("selectAll");
                }}
                title="select all"
                color="primary"
            >
                <CheckBoxOutlineBlankIcon />
            </IconButton>
    )
}